import { Loading } from "../../../Helper/Loading";
import { RipeningGraph } from "../../Layers/Layer/RipeningGraph";
import useRipeningRoom from "../hooks/useRipeningRoom";
import { GroupRipeningGraph } from "./GroupRipeningGraph";

export function CheckSessionRipeningFieldGraphs() {
    const { checkSessions, fruit_type } = useRipeningRoom();

    if (!checkSessions || !fruit_type) {
        return <Loading />;
    }
    return <RipeningGraph object_id={checkSessions?.[0]?.id} series={[checkSessions]} fruit_type={fruit_type as string} title={false} minHeight="45rem" />;
}


export function RipeningPalletsGraphs() {
    const { groups, pallets, fruit_type, checks, predictions } = useRipeningRoom();

    if (!pallets || !fruit_type || !checks || !groups) {
        return <Loading />;
    }

    return (
        <>
            {groups.map((group, index) => (
                <div key={group.group_key || `group-${index}`} className="mb-5">
                    <GroupRipeningGraph
                        groupLabel={group.group_label || "Ungrouped"}
                        groupPallets={group.items || []}
                        checks={checks}
                        predictions={predictions || []}
                        fruit_type={fruit_type as string}
                        minHeight="45rem"
                    />
                </div>
            ))}
        </>
    );
}
